var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { StickyHandler, StickyState } from './base-sticky-header';
import { addClass, removeClass } from '../../../core/utils/src/dom';
export var stickyVisibleClass = 'awsui-table-sticky';
export var stickyLeavingClass = 'awsui-table-sticky-leaving';
export var stickyActiveClass = 'awsui-table-sticky-active';
var StickyTableHeaderHandler = /** @class */ (function (_super) {
    __extends(StickyTableHeaderHandler, _super);
    function StickyTableHeaderHandler(node, verticalOffset) {
        var _this = _super.call(this, node, verticalOffset) || this;
        _this.stickyLeavingClass = stickyLeavingClass;
        _this.stickyVisibleClass = stickyVisibleClass;
        _this.stickyActiveClass = stickyActiveClass;
        return _this;
    }
    StickyTableHeaderHandler.prototype.updateHorizontalPosition = function (event) {
        if (this.shouldStick()) {
            var scrollLeft = event.target.scrollLeft;
            this.getStickyColumnHeaders().style.left = -scrollLeft + "px";
        }
    };
    StickyTableHeaderHandler.prototype.updateLayout = function () {
        _super.prototype.updateLayout.call(this);
        if (this.getCurrentStickyState() !== StickyState.DEFAULT) {
            this.updateColumnWidths();
        }
    };
    StickyTableHeaderHandler.prototype.updateColumnWidths = function () {
        if (this.getCurrentStickyState() === StickyState.DEFAULT) {
            return;
        }
        var header = this.getNonStickyColumnHeaders();
        var stickyHeader = this.getStickyColumnHeaders();
        var headerWidth = header.offsetWidth;
        var columnWidths = this.getColumns(header).map(function (element) { return element.getBoundingClientRect().width; });
        this.getColumns(stickyHeader).forEach(function (column, index) {
            var width = columnWidths[index];
            column.style.width = width + "px";
            column.style.maxWidth = width + "px";
        });
        stickyHeader.style.width = headerWidth + "px";
    };
    StickyTableHeaderHandler.prototype.getStickyNode = function () {
        return this.node.querySelector('.awsui-table-heading-container');
    };
    StickyTableHeaderHandler.prototype.getStrutOriginal = function () {
        return this.node.querySelector('.awsui-table-regions-container');
    };
    StickyTableHeaderHandler.prototype.getRootElement = function () {
        return this.node.querySelector('.awsui-table-inner');
    };
    StickyTableHeaderHandler.prototype.getHeaderStrut = function () {
        return this.node.querySelector('.awsui-table-heading-strut');
    };
    StickyTableHeaderHandler.prototype.getItemsContainer = function () {
        return this.node.querySelector('tbody');
    };
    StickyTableHeaderHandler.prototype.getStickyHeight = function () {
        return (this.getStrutOriginal().getBoundingClientRect().height +
            this.getNonStickyColumnHeaders().getBoundingClientRect().height);
    };
    StickyTableHeaderHandler.prototype.stateChangeHandler = function (state) {
        _super.prototype.stateChangeHandler.call(this, state);
        var stickyTHead = this.getStickyColumnHeaders();
        var mainTHead = this.getNonStickyColumnHeaders();
        removeClass(stickyTHead, this.stickyActiveClass);
        removeClass(mainTHead, this.stickyActiveClass);
        if (state === StickyState.STICKY) {
            addClass(stickyTHead, this.stickyActiveClass);
        }
        else {
            addClass(mainTHead, this.stickyActiveClass);
        }
    };
    StickyTableHeaderHandler.prototype.getColumns = function (rootElement) {
        return Array.prototype.slice.call(rootElement.querySelectorAll('th, td'));
    };
    StickyTableHeaderHandler.prototype.getStickyColumnHeaders = function () {
        return this.getStickyNode().querySelector('thead');
    };
    StickyTableHeaderHandler.prototype.getNonStickyColumnHeaders = function () {
        return this.node.querySelector('.awsui-table-container thead');
    };
    return StickyTableHeaderHandler;
}(StickyHandler));
export default StickyTableHeaderHandler;
//# sourceMappingURL=table-sticky-header.js.map